import React, { Component } from 'react';
import { Route, HashRouter, Switch, Router } from 'react-router-dom';
import { isWechat } from './common/utils.js';

import LoginRegister from './containers/AuthAndRegister/LoginRegister.js'

import './App.css';

const MyLoadingComponent = ({ error, pastDelay }) => {
	// Handle the loading state
	if (error) {
		return <div>加载失败。</div>;
	} else if (pastDelay) {
		return <div>加载中...</div>;
	} else {
		return null;
	}
};

// const LoginRegister = Loadable({
//   loader: () => {
//   	//import("./containers/AuthAndRegister/LoginRegister.css");
//   	return import('./containers/AuthAndRegister/LoginRegister.js')
//   },
//   loading: MyLoadingComponent,
//   delay: 3001
// });

// const ChartsRouter = Loadable({
//   loader: () => {
//   	//import("./containers/AuthAndRegister/LoginRegister.css");
//   	return import('./containers/DeviceChart/ChartsRouter.js')
//   },
//   loading: MyLoadingComponent,
//   delay: 2300
// });


class App extends Component {

	componentWillMount() {
		//如果没在微信打开，则提示从微信打开
		// if(window.location.href.indexOf('WrongBrowerMsg') < 0 && !isWechat() && window.localStorage.getItem('DEBUG') != 'true'){
		//     let preLoadingIcon = document.getElementById("loadingIcon");
		//     if(preLoadingIcon){
		//         document.body.removeChild(preLoadingIcon);
		//     }
		//     window.location.replace(window.location.href.split('#')[0]+'#/WrongBrowerMsg');
		// }
	}
	componentDidMount() {
		// window.location.replace(window.location.href.split('#')[0] + '#/LoginRegister');

		let preLoadingIcon = document.getElementById("loadingIcon");
		if (preLoadingIcon) {
			document.body.removeChild(preLoadingIcon);
		}

		// 测试通过环境变量配置的JS文件打包
		//import('./'+process.env.REACT_APP_CONFIG_JS).then(result=>console.log(result));
	}

	render() {
		return (
			<HashRouter>
				<Switch>
					{/* <Route path="/LoginRegister/:encodedCallbackPage" component={LoginRegister} /> */}
					<Route path="/LoginRegister" component={LoginRegister} />
				</Switch>
			</HashRouter>
		);
	}
}

export default App;

//import DeviceCharts from './containers/DeviceStatistics/DeviceCharts.js';
//<Route path="/DeviceCharts" component={DeviceCharts} />

			// <Route path="/RemarkEditor/WorkSheet/:workSheetId" component={RemarkEditor} />
			// <Route path="/RemarkEditor/AlertEvent/:alertEventId" component={RemarkEditor} />
